import { FinancialOverviewLayoutSectionKey } from '../../types';

/**
 * Reorders the visible projection of an Overview layout while leaving hidden
 * modules in their existing slots in the canonical persisted order.
 */
export const reorderFinancialOverviewVisibleSections = (
    order: FinancialOverviewLayoutSectionKey[],
    visibleKeys: FinancialOverviewLayoutSectionKey[],
    sourceIndex: number,
    destinationIndex: number,
): FinancialOverviewLayoutSectionKey[] => {
    if (
        sourceIndex === destinationIndex ||
        sourceIndex < 0 ||
        destinationIndex < 0 ||
        sourceIndex >= visibleKeys.length ||
        destinationIndex >= visibleKeys.length
    ) {
        return order;
    }

    const nextVisibleKeys = [...visibleKeys];
    const [movedKey] = nextVisibleKeys.splice(sourceIndex, 1);

    nextVisibleKeys.splice(destinationIndex, 0, movedKey);

    const visibleKeySet = new Set(visibleKeys);
    let visibleIndex = 0;

    return order.map((key) => (visibleKeySet.has(key) ? nextVisibleKeys[visibleIndex++] : key));
};
